module.exports = __webpack_public_path__ + "static/media/hot-tub.91ed13d1.svg";